import BaseModel from './base-model';

/**
 * format:
 * @COMMON_NAME: "CT.AsignacionPerfilDiraya"
 * @REL_ATTR: "pcat:403643"
 * @id: 403643
 */
export default class Category extends BaseModel {
  constructor(opts = {}) {
    super(opts);
    this.id = opts['@id'] || null;
    this.name = opts['@COMMON_NAME'] || null;
  }
}
